export const roundupPrice = price => {
    if(String(price).includes(".")) {
        return price.toFixed(2)
    } else {
        return price
    }
}